<template>
  <el-table-column
    prop="creator_name"
    sortable="custom"
    label="Rögzítette"
    show-overflow-tooltip
    min-width="120"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.creator_user_name"
        style="display: inline-block;"
      >
        {{ scope.row.creator_user_name }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'creator_user.last_name',
};
</script>
